<template>
    <div class="g-galleria">
        <PGalleria 
        :value="valor"
        :showThumbnails="mostrarThumbnails"
        :circular="ImgRotativa"
        :showIndicators="mostrarIndicadores"
        :showItemNavigators="mostrarItensNavegadores"
        :activeIndex="itemInicial"
        :autoPlay="TrocaAutomatica"
        :transitionInterval="TempoIntervalo"
        >
        <template #item=slotProps>
                <div class="grid">                            
                    <div class="img-container">
                        <div class="img-box">
                            <img :src="'data:image/png;base64,' + slotProps.item.arquivobase64" style="width: 100%; cursor: pointer" @click="openModal(slotProps)" />
                        </div>
                    </div>
                </div>    
        </template>
        </PGalleria>

        <PGalleria :value="valor" containerStyle="max-width: 850px"
          :circular="ImgRotativa"
          :fullScreen="fullScreen"
          :showItemNavigators="mostrarItensNavegadores"
          :showThumbnails="mostrarThumbnails"
          :activeIndex="numeroImagemFullScreen"
          v-model:visible="popupFullScreen">
          <template #item="slotProps">
            <img :src="'data:image/png;base64,' + slotProps.item.arquivobase64" style="width: 100%; cursor: pointer; display: block;"  />
          </template>
        </PGalleria>
    </div>
</template>

<script>
import gGalleria from "./g-galleria.js";
export default gGalleria;
</script>




<style scoped>
.g-galleria{
  width:100%;
  
}

@media (min-width:310px) {
  :deep(.p-galleria-item-nav) {
    margin: 0 0.5rem;
}
}

@media (min-width:800px) {
  :deep(.p-galleria-item-nav) {
    
    color: v-bind('corSetas') !important;
}
}


@media (min-width:1025px) {

.grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 0px;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
}

  .img-container{
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.img-box{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 280px;
  height: fit-content;
  flex-direction: column;
} 

:deep(.p-galleria-item-nav) {
    
    color: v-bind('corSetas') !important;
}
}
</style>
